export var wordCount = function wordCount(str) {
  if (!str) {
    return 0;
  }

  var matches = str.match(/[^\s]+/g);
  return matches ? matches.length : 0;
};